/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'svgIconService' implicitly has an 'any'... Remove this comment to see the full error message
const SvgIcon = (svgIconService, $sce, locale) => ({
   restrict: 'E',

   // TODO: this HTML structure is odd, check it out if we can fix this (it now lives in an actual <svg-icon> element)
   template: `<span ng-if="textBefore" ng-bind="textBefore"></span> \
<span ng-class="iconClass"> \
<svg ng-class="svgClass" ng-attr-view_box="{{viewBox}}" ng-bind-html="data"></svg> \
</span> \
<span ng-if="text" ng-bind="text"></span>`,

   scope: {
      name: "@",
      viewbox: "@?",
      style: "@?",
      iconClass: "@?",
      svgClass: "@?",
      text: "<?",
      textBefore: "<?",
      flip: "<?",
      transform: "@?",
      flipForRtl: "<?"
   },

   link(scope: any, el: any, attr: any) {
      scope.data = $sce.trustAsHtml(svgIconService.get(scope.name))
      scope.iconClass = scope.iconClass || 'svgIcon' // to be overridden if you don't want the default icon size
      scope.viewBox = svgIconService.determineViewBox(scope.name)

      if (locale.localization.isRTL && scope.flipForRtl) {
         if (!scope.flip) {
            scope.transform = "scale(-1, 1)"
         }
      } else { 
         if (scope.flip) {
            scope.transform = "scale(-1, 1)"
         }
      }

      el.find('svg').attr('style', scope.style)
      return el.find('svg').attr('transform', scope.transform)
   }
})
    

// @ts-expect-error TS(7006) FIXME: Parameter 'svgIconService' implicitly has an 'any'... Remove this comment to see the full error message
const SvgIconRaw = (svgIconService, $sce, locale) => ({
   restrict: 'E',
   replace: true,
   template: '<svg ng-class="svgClass" ng-attr-view_box="{{viewBox}}" ng-bind-html="data"></svg>',

   scope: {
      name: "@",
      viewBox: "@?",
      svgClass: "@?",
      flip: "<?",
      transform: "@?",
      flipForRtl: "<?",
      style: "@?"
   },

   link(scope: any, el: any, attr: any) {
      scope.data = $sce.trustAsHtml(svgIconService.get(scope.name))
      scope.viewBox = svgIconService.determineViewBox(scope.name)

      if (locale.localization.isRTL && scope.flipForRtl) {
         if (!scope.flip) {
            scope.transform = "scale(-1, 1)"
         }
      } else { 
         if (scope.flip) {
            scope.transform = "scale(-1, 1)"
         }
      }
  
      attr.$set('style', scope.style)
      return attr.$set('transform', scope.transform)
   }
})

angular.module('summonApp.directives') 
   .directive('svgIcon', ['svgIconService', '$sce', 'localizationService', SvgIcon])
   .directive('svgIconRaw', ['svgIconService', '$sce', 'localizationService', SvgIconRaw])
